import { Route } from 'react-router';
import PrivateRoute from './PrivateRoute'
import ClientLayout from '../contexts/shared/components/layouts/ClientLayout'
import Home from '../contexts/frontoffice/Home'
import UserDetail from '../contexts/backoffice/users/ui/pages/UserDetail'
import Terms from '../contexts/frontoffice/Policies/Terms'
import KnowBuy from '../contexts/frontoffice/knowbuy/KnowBuy'
import CourseList from '../contexts/frontoffice/courses/ui/pages/CourseList'
import ClientLibrary from '../contexts/frontoffice/library/ui/pages/ClientLibrary'
import EventList from '../contexts/frontoffice/events/ui/pages/EventList'
import SeminarsHome from '../contexts/frontoffice/seminars/ui/pages/SeminarsHome'
import OffersHome from '../contexts/frontoffice/offers/ui/pages/OffersHome'
import NewsPanel from '../contexts/frontoffice/news/ui/pages/NewsPanel'
import NoveltyHome from '../contexts/frontoffice/novelties/ui/pages/NoveltyHome'
import Favorites from '../contexts/frontoffice/favorites/ui/pages/Favorites'


export const ClientRoutes = (
  <Route path="/" element={<PrivateRoute><ClientLayout /></PrivateRoute>}>
    <Route path="inicio" element={<Home />} />
    <Route path="perfil" element={<UserDetail />} />
    <Route path="terms" element={<Terms />} />
    <Route path="comercial" element={<KnowBuy />} />
    <Route path="cursos" element={<CourseList />} />
    <Route path="biblioteca" element={<ClientLibrary />} />
    <Route path="eventos" element={<EventList />} />
    <Route path="seminarios" element={<SeminarsHome />} />
    <Route path="ofertas" element={<OffersHome />} />
    <Route path="noticias" element={<NewsPanel />} />
    <Route path="novedades" element={<NoveltyHome />} />
    <Route path="favoritos" element={<Favorites />} />
  </Route>
);
